import { Directive, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { NgControl } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Directive({
  selector: '[aggregatefunction]'
})
export class AggregateFuctionFieldsDirective implements OnInit, OnDestroy{

  //disable the control which is not selected in execute and exempt form 
  // and also reset the value when changes

    @Input() aggregateFun: any;
    $destroy:Subject<boolean> = new Subject()
  
    constructor(private ngControl : NgControl) {}

    ngOnInit(): void {
        this.aggregateFun[2]
        .pipe(takeUntil(this.$destroy))
        .subscribe((val:string)=>{
            this.changeValue(val);
        })
    }

    changeValue (val:string) {
        if(val){
            if(val==='count'){
                this.ngControl.reset(this.aggregateFun[1][0].value)
            }else{
                this.ngControl.reset()
            }
        }
    
    }

    ngOnDestroy(): void {
        this.$destroy.next(true);
        this.$destroy.unsubscribe();
    }
}